module.exports = __webpack_public_path__ + "src/img/music.ada09b70.png";